<template>
  <div style="position: relative;">
    <!-- 图片验证区域 -->
    <div v-if="type === '2'" class="verify-img-out" :style="{ height: (parseInt(setSize.imgHeight) + vSpace) + 'px' }">
      <div class="verify-img-panel" :style="{
        width: setSize.imgWidth,
        height: setSize.imgHeight,
      }" v-if="blockBackImgBase">
        <img :src="backImgBase ? ('data:image/png;base64,' + backImgBase) : defaultImg" alt="" style="width:100%;height:100%;display:block">
        <div v-show="showRefresh" class="verify-refresh" @click="refresh"><i class="iconfont icon-refresh" /></div>
        <transition name="tips">
          <span v-if="tipWords" class="verify-tips" :class="passFlag ? 'suc-bg' : 'err-bg'">{{ tipWords }}</span>
        </transition>
      </div>
      <div v-else v-loading="blockBackImgBase ? false : true" style="width:100%;height:100%"></div>
    </div>

    <!-- 滑块区域 -->
    <div class="verify-bar-area" :style="{
      width: setSize.imgWidth,
      height: barSize.height,
      'line-height': barSize.height
    }" v-if="blockBackImgBase">
      <span class="verify-msg" v-text="text" />
      <div class="verify-left-bar" :style="{ width: (leftBarWidth !== undefined) ? leftBarWidth : barSize.height, height: barSize.height, 'border-color': leftBarBorderColor, transaction: transitionWidth }">
        <span class="verify-msg" v-text="finishText" />
        <div class="verify-move-block" :style="{ width: barSize.height, height: barSize.height, 'background-color': moveBlockBackgroundColor, left: moveBlockLeft, transition: transitionLeft }" @mousedown="start" @touchstart="start">
          <i :class="['verify-icon iconfont', iconClass]" :style="{ color: iconColor }" />
          <div v-if="type === '2' && blockBackImgBase" class="verify-sub-block" :style="{
            'width': Math.floor(parseInt(setSize.imgWidth) * 47 / 310) + 'px',
            'height': setSize.imgHeight,
            'top': '-' + (parseInt(setSize.imgHeight) + vSpace) + 'px',
            'background-size': setSize.imgWidth + ' ' + setSize.imgHeight,
          }">
            <img :src="'data:image/png;base64,' + blockBackImgBase" alt="" style="width:100%;height:100%;display:block">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { aesEncrypt } from '@/utils/crypto.js'
import { resetSize } from '@/utils/index.js'
import { reqGet, reqCheck } from './../api/index'

export default {
  name: 'VerifySlide',
  props: {
    captchaType: {
      type: String,
    },
    type: {
      type: String,
      default: '1'
    },
    // 弹出式pop，固定fixed
    mode: {
      type: String,
      default: 'fixed'
    },
    vSpace: {
      type: Number,
      default: 5
    },
    explain: {
      type: String,
      default: '向右滑动完成验证'
    },
    imgSize: {
      type: Object,
      default() {
        return {
          width: '310px',
          height: '155px'
        }
      }
    },
    blockSize: {
      type: Object,
      default() {
        return {
          width: '50px',
          height: '50px'
        }
      }
    },
    barSize: {
      type: Object,
      default() {
        return {
          width: '310px',
          height: '40px'
        }
      }
    },
    defaultImg: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      secretKey: '', // 后端返回的加密秘钥 字段
      passFlag: '', // 是否通过的标识
      backImgBase: '', // 验证码背景图片
      blockBackImgBase: '', // 验证滑块的背景图片
      backToken: '', // 后端返回的唯一token值
      startMoveTime: '', // 移动开始的时间
      endMovetime: '', // 移动结束的时间
      tipsBackColor: '', // 提示词的背景颜色
      tipWords: '',
      text: '',
      finishText: '',
      setSize: {
        imgHeight: 0,
        imgWidth: 0,
        barHeight: 0,
        barWidth: 0
      },
      top: 0,
      left: 0,
      moveBlockLeft: undefined,
      leftBarWidth: undefined,
      // 移动中样式
      moveBlockBackgroundColor: undefined,
      leftBarBorderColor: '#ddd',
      iconColor: undefined,
      iconClass: 'icon-right',
      status: false, // 鼠标状态
      isEnd: false,		// 是够验证完成
      showRefresh: true,
      transitionLeft: '',
      transitionWidth: '',
      isDragging: false, // 新增：跟踪拖动状态
      startX: 0,
      canDrag: true, // 新增：控制是否可以拖动的标志
    }
  },
  computed: {
    barArea() {
      return this.$el.querySelector('.verify-bar-area')
    },
    resetSize() {
      return resetSize
    }
  },
  watch: {
    // type变化则全面刷新
    type: {
      immediate: true,
      handler(val) {
        this.init()
      }
    }
  },
  mounted() {
    this.$el.onselectstart = () => false // 禁止选择文本
  },
  beforeDestroy() {
    document.removeEventListener('mousemove', this.move)
    document.removeEventListener('touchmove', this.move)
    document.removeEventListener('mouseup', this.end)
    document.removeEventListener('touchend', this.end)
  },
  methods: {
    init() {
      this.text = this.explain
      this.$nextTick(() => {
        const setSize = this.resetSize(this) // 重新设置宽度高度
        for (const key in setSize) {
          this.$set(this.setSize, key, setSize[key])
        }
        this.$parent.$emit('ready', this)
      })
      this.addEventListeners() // 添加事件监听器
    },

    // 添加事件监听器
    addEventListeners() {
      window.addEventListener('mousemove', this.move)
      window.addEventListener('touchmove', this.move)
      window.addEventListener('mouseup', this.end)
      window.addEventListener('touchend', this.end)
    },

    // 移除事件监听器
    removeEventListeners() {
      window.removeEventListener('mousemove', this.move)
      window.removeEventListener('touchmove', this.move)
      window.removeEventListener('mouseup', this.end)
      window.removeEventListener('touchend', this.end)
    },

    // 开始拖动
    start(e) {
      if (this.isEnd || !this.canDrag) return // 添加 canDrag 检查

      e = e.type.includes('touch') ? e.touches[0] : e
      this.startX = e.clientX
      this.startLeft = Math.floor(this.startX - this.barArea.getBoundingClientRect().left)
      this.startMoveTime = +new Date()

      this.text = ''
      this.moveBlockBackgroundColor = '#337ab7'
      this.leftBarBorderColor = '#337AB7'
      this.iconColor = '#fff'

      this.isDragging = true

      // 添加事件监听器
      document.addEventListener('mousemove', this.move)
      document.addEventListener('touchmove', this.move)
      document.addEventListener('mouseup', this.end)
      document.addEventListener('touchend', this.end)

      e.preventDefault()
    },

    // 拖动中
    move(e) {
      if (!this.isDragging || this.isEnd) return

      e = e.type.includes('touch') ? e.touches[0] : e
      const moveX = e.clientX - this.startX
      const barAreaLeft = this.barArea.getBoundingClientRect().left
      let moveBlockLeft = (e.clientX - barAreaLeft)

      // 限制移动范围
      const maxLeft = this.barArea.offsetWidth - parseInt(this.blockSize.width) / 2 - 2
      const minLeft = parseInt(this.blockSize.width) / 2
      moveBlockLeft = Math.min(Math.max(moveBlockLeft, minLeft), maxLeft)

      this.moveBlockLeft = `${moveBlockLeft - this.startLeft}px`
      this.leftBarWidth = `${moveBlockLeft - this.startLeft}px`

      e.preventDefault()
    },

    // 拖动结束
    end() {
      if (!this.isDragging) return

      this.isDragging = false
      this.endMovetime = +new Date()

      // 移除事件监听器
      document.removeEventListener('mousemove', this.move)
      document.removeEventListener('touchmove', this.move)
      document.removeEventListener('mouseup', this.end)
      document.removeEventListener('touchend', this.end)

      var moveLeftDistance = parseInt((this.moveBlockLeft || '').replace('px', ''))
      moveLeftDistance = moveLeftDistance * 310 / parseInt(this.setSize.imgWidth)

      const data = {
        captchaType: this.captchaType,
        'pointJson': this.secretKey ? aesEncrypt(JSON.stringify({ x: moveLeftDistance, y: 5.0 }), this.secretKey) : JSON.stringify({ x: moveLeftDistance, y: 5.0 }),
        'token': this.backToken
      }

      // 在发送验证请求前禁用拖动
      this.canDrag = false

      // 发送验证请求
      reqCheck(data).then(res => {
        if (res.data.code == 200) {
          // 验证成功
          this.moveBlockBackgroundColor = '#5cb85c'
          this.leftBarBorderColor = '#5cb85c'
          this.iconColor = '#fff'
          this.iconClass = 'icon-check'
          this.showRefresh = false
          this.isEnd = true
          this.passFlag = true
          this.tipWords = `${((this.endMovetime - this.startMoveTime) / 1000).toFixed(2)}s验证成功`

          var captchaVerification = this.secretKey ? aesEncrypt(this.backToken + '---' + JSON.stringify({ x: moveLeftDistance, y: 5.0 }), this.secretKey) : this.backToken + '---' + JSON.stringify({ x: moveLeftDistance, y: 5.0 })

          setTimeout(() => {
            this.tipWords = ''
            this.$parent.closeBox()
            this.$parent.$emit('success', { captchaVerification })
          }, 1000)
        } else {
          // 验证失败时的处理
          this.moveBlockBackgroundColor = '#d9534f'
          this.leftBarBorderColor = '#d9534f'
          this.iconColor = '#fff'
          this.iconClass = 'icon-close'
          this.passFlag = false

          // 将木块重置到初始位置
          this.moveBlockLeft = '0px'
          this.leftBarWidth = '0px'

          setTimeout(() => {
            this.refresh()
            // 延迟一段时间后才允许再次拖动
            setTimeout(() => {
              this.canDrag = true
            }, 300)
          }, 1000)

          this.$parent.$emit('error', this)
          this.tipWords = res.code == 6110 ? '接口验证失败数过多，请稍后再试' : '验证失败'
          setTimeout(() => {
            this.tipWords = ''
          }, 1000)
        }
      })
    },

    // 刷新
    refresh() {
      this.$nextTick(() => {
        this.showRefresh = true
        this.finishText = ''
        this.isDragging = false
        this.canDrag = true // 重置拖动状态

        this.transitionLeft = 'left .3s'
        this.moveBlockLeft = '0px' // 确保使用带单位的值

        this.leftBarWidth = '0px' // 确保使用带单位的值
        this.transitionWidth = 'width .3s'

        this.leftBarBorderColor = '#ddd'
        this.moveBlockBackgroundColor = '#fff'
        this.iconColor = '#000'
        this.iconClass = 'icon-right'
        this.isEnd = false

        this.getPictrue()
        setTimeout(() => {
          this.transitionWidth = ''
          this.transitionLeft = ''
          this.text = this.explain
        }, 300)
      })
    },

    // 获取图片
    getPictrue() {
      const data = {
        captchaType: this.captchaType,
        clientUid: localStorage.getItem('slider'),
        ts: Date.now(), // 现在的时间戳
      }
      reqGet(data).then(res => {
        if (res.data.code == 200) {
          this.backImgBase = res.data.data.originalImageBase64
          this.blockBackImgBase = res.data.data.jigsawImageBase64
          this.backToken = res.data.data.token
          this.secretKey = res.data.data.secretKey
        } else {
          this.tipWords = res.repMsg
        }

        // 判断接口请求次数是否失效
        if (res.code == '6201') {
          this.backImgBase = null
          this.blockBackImgBase = null
        }
      })
    },
  },
}
</script>


// WEBPACK FOOTER //
// src/views/verifition/Verify/VerifySlide.vue